export function usesArtifactCredentials(targetWindow = window) {
    return targetWindow.GLOBAL_INFO?.aiProjectArtifactConfig?.crossorigin === 'use-credentials';
}
export const getArtifactCrossOrigin = () => (usesArtifactCredentials() ? 'use-credentials' : 'anonymous');
const PATCH_KEY = Symbol.for('wuji.xy.artifactPreloadCredentials');
export function registerPreloadCredentials(moduleUrl, targetWindow = window, targetDocument = targetWindow.document) {
    if (!usesArtifactCredentials(targetWindow))
        return;
    let directory;
    try {
        directory = new URL('.', new URL(moduleUrl, targetDocument.baseURI));
    }
    catch {
        return;
    }
    if (directory.protocol !== 'http:' && directory.protocol !== 'https:')
        return;
    const head = targetDocument.head;
    if (!head)
        return;
    let scopes = head[PATCH_KEY];
    if (!scopes) {
        scopes = new Map();
        const registeredScopes = scopes;
        const originalAppendChild = head.appendChild;
        head.appendChild = function (node) {
            if (this === head && usesArtifactCredentials(targetWindow)) {
                const link = getResourceLink(node);
                if (link && matchesScope(link.href, registeredScopes)) {
                    // 插入后浏览器可能立即发起请求，不能等 MutationObserver 再改凭据。
                    link.crossOrigin = 'use-credentials';
                }
            }
            return originalAppendChild.call(this, node);
        };
        Object.defineProperty(head, PATCH_KEY, { value: scopes });
    }
    // 模块缓存和懒加载函数会继续存在，入口 dispose 时不能撤销这些范围。
    const paths = scopes.get(directory.origin) ?? new Set();
    paths.add(directory.pathname);
    scopes.set(directory.origin, paths);
}
function getResourceLink(node) {
    if (node?.nodeType !== 1)
        return null;
    const link = node;
    if (link.localName !== 'link' || link.namespaceURI !== 'http://www.w3.org/1999/xhtml')
        return null;
    const rels = link.rel.toLowerCase().split(/\s+/);
    if (rels.includes('modulepreload') || rels.includes('stylesheet'))
        return link;
    if (rels.includes('preload') && ['script', 'style'].includes((link.getAttribute('as') ?? '').toLowerCase()))
        return link;
    return null;
}
function matchesScope(href, scopes) {
    try {
        const url = new URL(href);
        const paths = scopes.get(url.origin);
        return paths !== undefined && [...paths].some(prefix => url.pathname.startsWith(prefix));
    }
    catch {
        return false;
    }
}
